// frontend/src/pages/LandingPage/PricingPage.jsx
import React, { useEffect } from 'react';
import HeaderPublic from '../../components/Navigation/HeaderPublic';
import PricingComparison from '../../components/LandingPage/PricingComparison';
import Footer from '../../components/LandingPage/Footer';

const PricingPage = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="bg-white shadow-sm">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <HeaderPublic />
                </div>
            </div>

            <main>
                <PricingComparison />
            </main>

            <Footer />
        </div>
    );
};

export default PricingPage;
